import { render, staticRenderFns } from "./Annot8UI.vue?vue&type=template&id=13d17db4&"
import script from "./Annot8UI.vue?vue&type=script&lang=js&"
export * from "./Annot8UI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports